import React from 'react';
import Auth0Lock from 'auth0-lock';
import config from 'config';
import backgroundImg from '../../images/DarkHorseRowingBackdrop.png';


const lockOptions = {
  allowedConnections: ['facebook', 'Username-Password-Authentication'],
  autoclose: true,
  avatar: null,
  container: 'auth0-lock-container',
  theme: {
    logo: 'https://res.cloudinary.com/dljcvcx8l/image/upload/v1497479292/DHR-logo-small_qfabm3.png',
    labeledSubmitButton: true,
    primaryColor: '#1C83CF'
  },
  socialButtonStyle: 'big',
  auth: {
    redirectUrl: 'http://localhost:8000/pay', //TO DO: change to custom page for payments, that also shows a success message,
    autoParseHash: true,
    responseType: 'token',
  },
  allowLogin: false,
  autofocus: true

  // Save: can use the current user's email to pre-populate this
  // prefill: {
  //   email: 'jacob@trybe.do',
  // },
}

const lock = new Auth0Lock(config.authClientID, config.authDomain, lockOptions);



class PaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      card: {
        number: '',
        cvc: '',
        exp_month: '',
        exp_year: ''
      },
      loading: true,
      stripeLoading: true
    };
  }

  componentDidMount() {
    lock.show();
    const _this = this;

    lock.on('hash_parsed', function(authResult) {
      if(authResult == null && localStorage.getItem('trybeIdToken') == null) {
        lock.show();
      } else {
        localStorage.setItem('trybeIdToken', authResult.idToken);

        lock.getUserInfo(authResult.accessToken, function(error, profile) {
          if(error) return;

          _this.setState({profile});
          _this.openStripe.bind(_this)();
          //To do: create firebase profile, with email and trybe
        });
      }
    });

    this.loadStripe(() => {
      this.stripehandler = window.StripeCheckout.configure({
        key: 'pk_test_ruGo48UpLyx1iAtkzujEzamd',
        image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
        locale: 'auto',
        zipCode: true,
        token: (token) => {
          this.setState({ loading: true });

          token.trybeId = 'Dark Horse Rowing';
          token.plan = 'dark_horse_rowing_sub_month';
          // token.plan = 'dark_horse_rowing_sub_year';
          // token.plan = 'dark_horse_rowing_sub_affiliate_month';
          // token.plan = 'dark_horse_rowing_sub_affiliate_year';

          token.firstName = 'Jacob';
          token.lastName = 'Jacobson';

          this.props.actions.signUpActions.sendPayment(token);
        }
      });

      this.setState({
        stripeLoading: false
      });
    });
  }

  componentWillUnmount() {
    if(this.stripehandler) {
      this.stripehandler.close();
    }
  }

  loadStripe(onload:Function) {
    if(!window.StripeCheckout) {
      const script = document.createElement('script');
      script.onload = function () {
        onload();
      };
      script.src = 'https://checkout.stripe.com/checkout.js';
      document.head.appendChild(script);
    } else {
      onload();
    }
  }

  openStripe(e:Object) {
    this.stripehandler.open({
      name: 'Dark Horse Rowing',
      description: '2 widgets',
      amount: 2000,
      allowRememberMe: false,
      image: 'https://res.cloudinary.com/dljcvcx8l/image/upload/v1497479292/DHR-logo-small_qfabm3.png',
      panelLabel: 'Join', //can also be Subscribe, Get Access, depending on the package
      zipCode: true,
      email: this.state.profile ? this.state.profile.email : null
    });
  }

  onPressStripe(e){
    this.openStripe();
    e.preventDefault();
  }



  handleSubmit(e) {
    e.preventDefault();
    Stripe.createToken(this.state.card, function (status, response) {
      console.log( status, response );
    });
  }

  handleChange(e) {
    let card = this.state.card;
    card[e.target.name] = e.target.value
    this.setState(card);
  }

  render() {
    const trybeIdToken = localStorage.getItem('trybeIdToken');

    let showLockWidget = true;
    // if(trybeIdToken) showLockWidget = false

    const lockStyle = showLockWidget ? {} : {opacity: 0, height: 0, width: 0, position: 'absolute', top: -9999};
    // localStorage.removeItem('trybeIdToken');

    var sectionStyle = {
      width: "100%",
      height: "500px",
      backgroundImage: `url(${backgroundImg})`,
      backgroundPosition: 'center'
    };


    return (
      <div>
        <section style={ sectionStyle }>
        </section>


        <span style={lockStyle}>
          <div id='auth0-lock-container' />
          <style jsx>{`
            #lock-container {
              margin: 30px 0 0;
            }
          `}</style>
          <style jsx global>{`
            .auth0-lock-header {
              display: none;
            }
          `}</style>
        </span>
      </div>
    );

    /*
      const { stripeLoading, loading } = this.state;

      {stripeLoading ?
          <p>loading..</p>
          : <button onClick={ this.openStripe.bind(this) }>Add CC</button>
      }

     */
    // return (
    //   <div>
    //     <form onSubmit={ this.handleSubmit.bind(this) }>
    //       <input size="20" name="number" onChange={ this.handleChange.bind(this) } />
    //       <input size="4" name="cvc" onChange={ this.handleChange.bind(this) } />
    //       <input size="2" name="exp_month" onChange={ this.handleChange.bind(this) } />
    //       <input size="4" name="exp_year" onChange={ this.handleChange.bind(this) } />
    //       <button type="submit">Pay</button>
    //     </form>
    //   </div>
    // )
  }
}

module.exports = PaymentForm;



// WEBPACK FOOTER //
// ./src/components/signUp/IN_PROGRESS_PaymentForm.js